import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ListSavedSearchEntity } from './list-saved-search.entity';
import { RbacRoleEntity } from './rbac-role.entity';

@Index(
	'idx_list_saved_search_role_unique',
	['fkSavedSearchId', 'fkRbacRoleId'],
	{
		unique: true,
	},
)
@Index('idx_list_saved_search_role_search', ['fkSavedSearchId'])
@Index('idx_list_saved_search_role_role', ['fkRbacRoleId'])
@Entity('list_saved_search_role')
export class ListSavedSearchRoleEntity extends BaseEntity {
	@Column('int', { name: '_fk_saved_search__id', unsigned: true })
	public fkSavedSearchId!: number;

	@Column('int', { name: '_fk_rbac_role__id', unsigned: true })
	public fkRbacRoleId!: number;

	@ManyToOne(
		() => ListSavedSearchEntity,
		(savedSearch) => savedSearch.sharedRoles,
		{
			onDelete: 'CASCADE',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([{ name: '_fk_saved_search__id', referencedColumnName: 'id' }])
	public fkSavedSearch!: ListSavedSearchEntity;

	@ManyToOne(() => RbacRoleEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_rbac_role__id', referencedColumnName: 'id' }])
	public fkRbacRole!: RbacRoleEntity;
}
